import { Container, Flex, Text, Box, SimpleGrid, Grid } from "@chakra-ui/react";
import React from "react";
import { TextSphere } from "../Components/TextSphere";
import { TextSpan } from "../Components/TextSpan";
import globe from "../Images/globeWhite.png";
import styled from "styled-components";
import paintBrush from "../Images/paintBrush.svg";
import paintBrushNew from "../Images/paintBrush-new.svg";
import paintRoller from "../Images/paintRoller.webp";
import html from "../Images/html.png";
import css from "../Images/css2.png";
import js from "../Images/javascript.png";
import react from "../Images/react.png";
import redux from "../Images/redux.png";
import nodejs from "../Images/nodejs.png";
import typescript from "../Images/typescript.png";
import python from "../Images/python.png";
import mongodb from "../Images/mongodb.png";
import chakra from "../Images/chakra.png";
import tailwind from "../Images/tailwind.png";
import flask from "../Images/flask.png";
import npm from "../Images/npm.png";
import vscode from "../Images/vscode.png";
import github from "../Images/github.png";
import postman from "../Images/postman.png";

export const Skills = () => {
  const sentence3 = "This box seems to be empty, but its not".split("");

  return (
    <Container
      id="skills"
      color="white"
      bg="black"
      maxW="100%"
      // h="92vh"
      h={{ base: "auto", md: "auto", lg: "92vh" }}
    >
      <Text
        fontSize={{ base: "22px", md: "30px", lg: "40px" }}
        fontFamily="'Mogra', cursive"
        p = "20px"
      >
        Time to showcase some skills!
      </Text>
      <br />
      <Flex
        position="relative"
        justifyContent="space-between"
        alignItems={"center"}
      >
        {/* <Box border="1px solid green"></Box> */}

        <Flex
          color="black"
          flexDirection="column"
          p="30px"
          width={{ base: "100%", lg: "50%" }}
          className="skills-card"
          columns={3}
          justifyContent="space-around"
          alignItems="center"
          placeItems={"center"}
          // mt = {{base : "55vh" , lg : "0"}}
          // display={{ base: "none", lg: "flex" }}
        >
          <Flex width="100%" flexDirection={"column"} gap="5">
            <Text
              fontSize={{ base: "20px", md: "24px", lg: "32px" }}
              fontFamily="'Mogra', cursive"
              className="skills-card-name"
              color="white"
            >
              Technical Skills
            </Text>

            <Grid
              gap="5"
              placeItems={"center"}
              width="100%"
              gridTemplateColumns={{
                base: "repeat(3,1fr)",
                sm : "repeat(6,1fr)", 
                md : "repeat(6,1fr)", 
                lg: "repeat(6,1fr)",
              }}
              // border="1px solid red"
            >
              <img
                className="skills-card-img"
                src={html}
                alt="check"
                style={{ width: "65%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src={css}
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src={js}
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src={react}
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src={redux}
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img className="skills-card-img" src={tailwind} alt="check" />

              <img
                className="skills-card-img"
                src={chakra}
                alt="check"
                style={{ width: "80%" }}
              />

              <img className="skills-card-img" src={typescript} alt="check" />

              <img
                className="skills-card-img"
                src={nodejs}
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src={mongodb}
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src={python}
                alt="check"
                style={{ width: "80%" }}
              />

              <img className="skills-card-img" src={flask} alt="check" />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
            </Grid>
          </Flex>

          <Flex width="100%" flexDirection={"column"} gap="5">
            <Text
              mt="5"
              fontSize={{ base: "20px", md: "24px", lg: "32px" }}
              fontFamily="'Mogra', cursive"
              className="skills-card-name"
              color="white"
            >
              Tools
            </Text>

            <Grid
              gap="5"
              placeItems={"center"}
              width="100%"
              gridTemplateColumns={{
                base: "repeat(3,1fr)",
                sm : "repeat(6,1fr)", 
                md : "repeat(6,1fr)", 
                lg: "repeat(6,1fr)",
              }}
            >
              <img
                className="skills-card-img"
                src={npm}
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src={github}
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src={vscode}
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src="https://www.svgrepo.com/show/331495/netlify.svg"
                alt="check"
                style={{ width: "80%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src="https://payalsahuj.github.io/static/media/AI.a2379f09e877a16c084a.webp"
                alt="check"
                style={{ width: "85%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
              <img
                className="skills-card-img"
                src={postman}
                alt="check"
                style={{ width: "90%" }}
              />
              {/* <Text className="skills-card-name" color="white">
              HTML
            </Text> */}
            </Grid>
          </Flex>

          {/* <HoverStyle>
            <Text fontSize="40px" color="white" fontFamily="'Mogra', cursive">
              This box seems to be empty, but its not
            </Text>

            <Box border="1px solid skyblue" height="auto">
              <Text
                className="my-text"
                width="fit-content"
                ml="60px"
                fontSize="40px"
                id="user-detail-name"
              >
                {sentence3.map((letter, index) => {
                  return (
                    <TextSpan key={index}>
                      {letter === " " ? "\u00A0" : letter}
                    </TextSpan>
                  );
                })}
                <br />
                {sentence3.map((letter, index) => {
                  return (
                    <TextSpan key={index}>
                      {letter === " " ? "\u00A0" : letter}
                    </TextSpan>
                  );
                })}
                <br />
                {sentence3.map((letter, index) => {
                  return (
                    <TextSpan key={index}>
                      {letter === " " ? "\u00A0" : letter}
                    </TextSpan>
                  );
                })}
              </Text>
            </Box>
          </HoverStyle> */}
        </Flex>
        {/* <GlobeImg
          src={globe}
          // style={{ width: "45%", border: "1px solid red" }}
          alt=""
        /> */}
        <TextSphere />
      </Flex>
    </Container>
  );
};

const HoverStyle = styled.div`
  &:hover {
    cursor: url(${paintBrush}), auto;
  }
`;

const GlobeImg = styled.img`
  width: 45%;
  /* border: 1px solid blue; */

  @media screen and (max-width: 768px) {
    display: none;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    display: none;
  }
`;
